import { VendorBuyingAgreementRebateCategoriesList } from '../../../components/Vendor';

export function BuyingAgreementRebateCategories() {
  return <VendorBuyingAgreementRebateCategoriesList />;
}
